<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
  <form
    #fdf="ngForm"
    (ngSubmit)="OnSaveBranchEmployeeProcessModel()"
    novalidate
  >
    <div class="formborder" style="padding: 0.625rem 0.9375rem !important;">
      <div class="row m-0 col-md-12 p-0" style="align-items: flex-end;">
        <div class="col-md-4">
          <span> Select Branch </span>
          <select
            name="FilterBranchId"
            id="FilterBranchId"
            [(ngModel)]="FilterBranchId"
            required
            #refFilterBranchId="ngModel"
            [ngClass]="{
              'is-invalid': fdf.submitted && refFilterBranchId.invalid,
              'alert-warning':
                refFilterBranchId.invalid &&
                (refFilterBranchId.dirty ||
                  refFilterBranchId.touched ||
                  refFilterBranchId.untouched)
            }"
            class="form-control input-text-css"
          >
            <option value="">Select Branch</option>
            <option
              *ngFor="let filterBranchList of FilterBranchList"
              [value]="filterBranchList.BranchId"
            >
              {{ filterBranchList.Branch_Name }}
            </option>
          </select>
        </div>
        <div class="col-md-4">
          <span> Select Product </span>
          <select
            name="FilterProductId"
            id="FilterProductId"
            [(ngModel)]="ProductId"
            required
            #refFilterProductId="ngModel"
            [ngClass]="{
              'is-invalid': fdf.submitted && refFilterProductId.invalid,
              'alert-warning':
                refFilterProductId.invalid &&
                (refFilterProductId.dirty ||
                  refFilterProductId.touched ||
                  refFilterProductId.untouched)
            }"
            class="form-control input-text-css"
          >
            <option value="">Select Product</option>
            <option
              *ngFor="let Product of productList"
              [value]="Product.ProductId"
            >
              {{ Product.Product }}
            </option>
          </select>
        </div>
        <div class="col-md-4">
          <div class="d-flex align-items-center" style="gap: 0.75rem; height: 2.125rem; margin-bottom: 0.75rem;">
            <button
              type="button"
              (click)="getBranchEmployeeProcessList()"
              [disabled]="!fdf.form.valid"
              class="search-btn"
            >
              <i class="fas fa-search"></i> Search
            </button>
            <button
              type="button"
              (click)="AddBranchEmployeeProcess()"
              [disabled]="!fdf.form.valid"
              class="add-btn"
            >
              <i class="fas fa-plus"></i> Add Process
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div
    class="formborder mt-3 cards-wrapper"
    *ngIf="showResults"
  >
    <div class="cards-container" style="display: flex; gap: 1rem; width: 100%;">
      <div *ngFor="let card of cardsData; let i = index" class="card process-card" style="width: 351px; flex-shrink: 0;">
        <div
          class="card-header"
          style="
            display: flex;
            background-color: #0e5c81;
            color: white;
            justify-content: space-between;
            align-items: center;
            border-radius: 7px 7px 0 0;
          "
        >
          <span>Branch Product Process</span>

          <span
            ><i
              style="color: #fff !important; cursor: pointer; font-size: 18px"
              class="fas fa-lg fa-edit margin-right-2xs"
              aria-label="true"
              (click)="EditBranchEmployeeProcess(card.Id,card,i)"
            ></i
          ></span>

          <span>
            <i
              class="fa fa-trash style-delete"
              style="cursor: pointer; font-size: 18px"
              *ngIf="i==cardsData.length-1"
                 (click)="DeleteBranchEmployeeProcess(card.Id)"
              aria-label="true"
            ></i>
          </span>
        </div>

        <div class="card-amount-range">
          <div class="amount-item">
            <span>From Amount</span>
            <strong>₹{{ card.fromAmount | number:'1.0-0' }}</strong>
          </div>
          <div class="amount-item">
            <span>To Amount</span>
            <strong>₹{{ card.toAmount | number:'1.0-0' }}</strong>
          </div>
        </div>

        <div class="table-container">
          <table class="process-table">
            <thead>
              <tr>
                <th>Process Name</th>
                <th>Employee Name</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let processAndEmployee of card.processAndEmployee">
                <td>
                  <span class="process-badge">{{ processAndEmployee.processName }}</span>
                </td>
                <td class="employee-names">{{ processAndEmployee.employeeName }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade in"
  id="BranchEmployeeProcessModel"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <form #ff="ngForm" novalidate>
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header" style="padding: 0.625rem">
          <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
            {{ isEditMode ? "Edit" : "Add" }} Branch Product Process
          </h6>
          <button
            type="button"
            (click)="OnCloseBranchEmployeeProcess()"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">
              <i class="far text-black fa-times-circle"></i>
            </span>
          </button>
        </div>
        <div class="modal-body formborder m-3">
          <div
            class="row m-0 font-size-12 align-items-center d-flex flex-column"
          >
            <div class="col-md-12">
              <span class="required-lable">From Amount</span>

              <input
                required
                type="number"
                #refFromAmount="ngModel"
                [ngClass]="{
                  'is-invalid': ff.submitted && refFromAmount.invalid,
                  'alert-warning':
                    refFromAmount.invalid &&
                    (refFromAmount.dirty ||
                      refFromAmount.touched ||
                      refFromAmount.untouched)
                }"
                [(ngModel)]="FromAmount"
                placeholder="From Amount"
                disabled
                name="FromAmount"
                id="FromAmount"
                class="form-control input-text-css"
              />
            </div>
            <div class="col-md-12">
              <span class="required-lable">To Amount</span>

              <input
                required
                type="number"
                [disabled]="isEditMode && !isLastSlab"
                #refToAmount="ngModel"
                [ngClass]="{
                  'is-invalid': ff.submitted && refToAmount.invalid,
                  'alert-warning':
                    refToAmount.invalid &&
                    (refToAmount.dirty ||
                      refToAmount.touched ||
                      refToAmount.untouched)
                }"
                [(ngModel)]="ToAmount"
                placeholder="To Amount"
                name="ToAmount"
                id="ToAmount"
                class="form-control input-text-css"
              />
              <div
                *ngIf="
                  FromAmount !== undefined &&
                  ToAmount !== undefined &&
                  ToAmount !== null &&
                  !validateAmounts()
                "
                class="alert alert-danger mt-1"
              >
                To Amount must be greater than From Amount.
              </div>
            </div>
            <div class="table-responsive mt-2" [hidden]="!dataSource">
              <table mat-table [dataSource]="dataSource">
                <!-- Name Column -->
                <ng-container matColumnDef="Process">
                  <th mat-header-cell *matHeaderCellDef>Process</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.Process }}
                  </td>
                </ng-container>

                <!-- Custom Multi-Select Column -->
                <ng-container matColumnDef="Employee">
                  <th mat-header-cell *matHeaderCellDef>Employee</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <mat-form-field>
                      <mat-select
                        name="SelectionEmps{{ i }}"
                        id="SelectionEmps{{ i }}"
                          [(ngModel)]="element.selectedOptions"
                        multiple
                        (selectionChange)="
                          onSelectionChange($event.value, element)
                        "
                      >
                        <mat-option
                          *ngFor="let option of element.EmployeeProcessList"
                          [value]="option.EmpIdIdentity"
                          >{{ option.Emp_Name }}</mat-option
                        >
                      </mat-select>
                    </mat-form-field>
                  </td>
                </ng-container>

                <!-- Set up Column Definitions -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"
                ></tr>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer" style="border: none">
          <button
            type="button"
            (click)="OnSaveBranchEmployeeProcessModel()"
            class="mt-3 btn font-size-12 button-btn"
            [disabled]="!ff.form.valid || !validateAmounts() || !ToAmount"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
